import { render, staticRenderFns } from "./DSP.vue?vue&type=template&id=1c38dc5e&scoped=true"
import script from "./DSP.vue?vue&type=script&lang=js"
export * from "./DSP.vue?vue&type=script&lang=js"
import style0 from "./DSP.vue?vue&type=style&index=0&id=1c38dc5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38dc5e",
  null
  
)

export default component.exports